import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {LinkContainer} from 'react-router-bootstrap'
import {Container, Nav, Navbar, NavDropdown} from 'react-bootstrap';
import { logout } from '../actions/userActions';

function Header() {
  const dispatch = useDispatch();
  const userLogin = useSelector(state => state.userLogin);
  const {userInfo} = userLogin;

  const logoutHandler = () => {
    dispatch(logout());
  }

  return (
    <header>
    <Navbar expand="lg" variant='dark' className="site-navbar" collapseOnSelect>
      <Container fluid>
        <LinkContainer to="/">
          <Navbar.Brand>
            <i className="fa-solid fa-graduation-cap"></i>
            <span className="brand-text">Series 65 FC</span>
          </Navbar.Brand>
        </LinkContainer>
        {/* Slot for study-type buttons injected by SectionDetailScreen when scrolled */}
        <div id="navbar-study-slot" style={{ display:'flex', alignItems:'center', marginLeft:'auto', marginRight:'0.5rem', gap:6 }}></div>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0" navbarScroll>
            {userInfo && (
              <LinkContainer to="/course">
                <Nav.Link><i className="fa-solid fa-book-open me-1"></i>Course</Nav.Link>
              </LinkContainer>
            )}
          </Nav>
          <Nav>
            {userInfo ? (
              <NavDropdown title={<><i className="fa-solid fa-circle-user me-1"></i>{userInfo.name}</>} id="navbarScrollingDropdown" align="end">
                <LinkContainer to="/profile"><NavDropdown.Item><i className="fa-solid fa-id-card me-2"></i>Account</NavDropdown.Item></LinkContainer>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={logoutHandler}><i className="fa-solid fa-right-from-bracket me-2"></i>Logout</NavDropdown.Item>
              </NavDropdown>
            ) : (
              <LinkContainer to="/login">
                <Nav.Link><i className="fa-solid fa-user me-1"></i>Login</Nav.Link>
              </LinkContainer>
            )}
            {userInfo && userInfo.isAdmin && (
              <NavDropdown title={<><i className="fa-solid fa-shield-halved me-1"></i>Admin</>} id="adminDropdown" align="end">
                <LinkContainer to="/admin/userList"><NavDropdown.Item>View Users</NavDropdown.Item></LinkContainer>
              </NavDropdown>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </header>
  );
}

export default Header
